import { useMutation } from "react-query";
import type { Paywall } from "@/react/types";
import { paywallCheckoutApi } from "@circle-react/api/paywallCheckoutApi";
import type {
  ShowEndpointQueryParams,
  ShowResponseEndpoint,
} from "@circle-react/api/paywallCheckoutApi.types";
import type { PaywallHandlerError } from "@circle-react/contexts/Paywalls/usePaywallCheckout";
import type { CheckoutPreviewContext } from "../../types/CheckoutProps";
import { fetchMockedData } from "./fetchMockedData";

interface UseCouponPreviewMutationProps {
  checkoutPreviewContext?: CheckoutPreviewContext;
  paywall: Paywall;
}

export type PaywallPreviewCouponApplication = Pick<
  ShowResponseEndpoint,
  "paywall" | "paywall_coupon"
>;

export const useCouponPreviewMutation = ({
  checkoutPreviewContext,
  paywall,
}: UseCouponPreviewMutationProps) => {
  const mockedMutation = useMutation<
    PaywallPreviewCouponApplication,
    PaywallHandlerError,
    ShowEndpointQueryParams
  >(fetchMockedData(paywall, checkoutPreviewContext));

  const mutation = useMutation<
    PaywallPreviewCouponApplication,
    PaywallHandlerError,
    ShowEndpointQueryParams
  >(paywallCheckoutApi.show);

  if (checkoutPreviewContext && paywall) {
    return mockedMutation;
  }

  return mutation;
};
